/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'FormStateJobLine';

export const KEYS = {
  LINE: 'line',
  AUTO_GENERATE_JOB_NUMBER: 'blnAutoGenerateJobNumber',
  JOB_NUMBER: 'job',
  JOB_START_DATE: 'jobStartDate',
  JOB_END_DATE: 'jobEndDate',
  JOB_DESCRIPTION: 'jobDescription',
  JOB_STATUS: 'jobStatus',
  AEGION_PROJECT_MANAGER: 'aegionProjectManager',

  CUSTOMER: 'customer',
  CUSTOMER_ENTITY: 'customerEntity',
  CUSTOMER_AREA: 'customerArea',
  CUSTOMER_PIPE: 'customerPipe',
  CUSTOMER_REG_STATUS: 'customerRegStatus',
  CUSTOMER_PROJECT_MANAGER: 'customerProjectManager',
  CUSTOMER_CORROSION_TECHNICIAN: 'customerCorrosionTechnician',
};

